/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const AppRoutes = {
  login: {
    path: '/login'
  },
  projects: {
    url: '/processings',
    index: {
      path: '/processings/*',
      url: () => '/processings'
    },
    detail: {
      path: '/projects/*',
      url: (project_url: string) => `/processings${project_url.startsWith('/') ? project_url : '/' + project_url}`
    }
  },
  spaces: {
    url: '/spaces',
    index: {
      path: '/spaces/*',
      url: () => '/spaces'
    },
    detail: {
      path: '/projects/*',
      url: (project_url: string) => `/spaces${project_url.startsWith('/') ? project_url : '/' + project_url}`
    }
  },
  processes: {
    list: {
      path: '/processes'
    },
    detail: {
      path: '/process/:id',
      url: (processID: string) => '/process/'.concat(processID)
    }
  },
  jobs: {
    index: {
      path: '/jobs/*',
      url: () => '/jobs'
    },
    detail: {
      path: ':id',
      url: (jobID: string) => '/jobs/'.concat(jobID)
    },
    list: {
      path: '/jobs'
    },
    processHistory: {
      path: 'history/*',
      url: (processId: string) => `/jobs/history/${processId}`
    }
  },
  trigger: {
    index: {
      path: '/triggers/*',
      url: () => '/triggers'
    },
    list: {
      path: 'list',
      url: () => '/triggers/list'
    },
    edit: {
      path: 'edit/:triggerId',
      url: (triggerId: string | number) => `/triggers/edit/${triggerId}`
    },
    new: {
      path: 'new'
    },
    detail: {
      path: 'detail/:triggerId',
      url: (triggerId: string | number) => `/triggers/detail/${triggerId}`
    }
  },
  docs: {
    path: '/docs'
  }
};
